import qs from 'qs';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { easyFetch, authEasyFetch } from './endpoint';

/* eslint-disable  @typescript-eslint/no-explicit-any */
export const fetchArticleList = createAsyncThunk('article/fetchArticleList', async (params: object) => {
    const { list, total } = await easyFetch<any>('api/article/list', 'GET', qs.stringify(params, { arrayFormat: 'brackets' }));
    return Promise.resolve({ list, total });
});

export const fetchArticleHighlightList = createAsyncThunk('article/fetchArticleHighlightList', async () => {
    const { list } = await easyFetch<any>('api/article/highlight', 'GET');
    return Promise.resolve({ list });
});

export const fetchArticleDetail = createAsyncThunk('article/fetchArticleDetail', async (articleId: string) => {
    const {
        content, nextArticle, prevArticle, recommendation
    } = await easyFetch<any>(`api/article/${articleId}`, 'GET');

    return Promise.resolve({
        content, nextArticle, prevArticle, recommendation
    });
});

export const fetchPreviewArticle = createAsyncThunk('article/fetchPreviewArticle', async (articleId: string) => {
    const {
        content, nextArticle, prevArticle, recommendation
    } = await authEasyFetch<any>(`/api/admin/article/preview/${articleId}`, 'GET');

    return Promise.resolve({
        content, nextArticle, prevArticle, recommendation
    });
});

export const searchArticle = createAsyncThunk('article/searchArticle', async (params: object) => {
    const {
        list, total, currentPage, lastPage, keywordList, recommendation
    } = await easyFetch<any>('api/article/search', 'GET', qs.stringify(params, { arrayFormat: 'brackets' }));

    return Promise.resolve({
        list, total, currentPage, lastPage, keywordList, recommendation
    });
});
